import {
  GridCellProps,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { EnumerationCell } from "../../Layout/Grid/Cell/Default/EnumCell";
import { controlDepartmentAsString } from "../../Project/ViewModel/ControlDepartment";

export const controlDepartmentTypeEnumCell = (props: GridCellProps) => (
  <EnumerationCell {...props} mapping={controlDepartmentAsString} />
);

export const controlDepartmentTypeColumnMenu = (props: GridColumnMenuProps) => {
  return (
    <GridColumnMenuCheckboxFilter
      expanded
      filterable
      data={[
        { LaunchClassification: "Plant EDC 1" },
        { LaunchClassification: "Central FTL" },
        { LaunchClassification: "ODC MGT" },
        { LaunchClassification: "Plant EDC 4" },
        { LaunchClassification: "CCT" },
        { LaunchClassification: "LTL To Plant" },
        { LaunchClassification: "JIT Kanban" },
        { LaunchClassification: "Rail" },
        { LaunchClassification: "Other" },
        { LaunchClassification: "Non LLP" },
        { LaunchClassification: "-" },
      ]}
      searchBox={() => null}
      {...props}
    />
  );
};
